/* Ported from the vhc prototype's kit (src/pages/AIGenerated/vhc/components) — it had
   no equivalent here, so it moved rather than being replaced. */
import clsx from 'clsx';

import s from './SuccessCheck.module.scss';

/**
 * The tick that says a thing worked — a vessel profile completed, a payment
 * taken, a wizard finished.
 *
 * Drawn rather than dropped in: the ring sweeps round and the tick draws itself
 * along its own path, which reads as *the moment it happened* instead of a
 * static ✓ that was presumably always there. Every screen that wanted this had
 * been settling for a plain icon or a toast.
 *
 * `size` is the only knob. Under `prefers-reduced-motion` the whole thing
 * arrives finished — the same mark, no drawing.
 *
 * @alias tick, checkmark, done animation, confirmation mark
 */
export const SuccessCheck = ({
  size = 64,
  tone = 'success',
  className,
  label = 'Done',
}: {
  size?: number;
  /** `neutral` for a confirmation that is not a celebration. */
  tone?: 'success' | 'neutral';
  className?: string;
  /** Announced once; the visual is decorative. */
  label?: string;
}) => (
  <span
    className={clsx(s.root, tone === 'neutral' && s.neutral, className)}
    style={{ width: size, height: size }}
    role="img"
    aria-label={label}
  >
    <svg viewBox="0 0 52 52" className={s.svg} aria-hidden="true">
      <circle className={s.ring} cx="26" cy="26" r="24" />
      <path className={s.tick} d="M14 27.5 L22.5 36 L38 18" />
    </svg>
  </span>
);
